export default __webpack_public_path__ + "static/tablets_teal-e35bc9a5d10f0e726aa0b68060ec9610.png";